import React from "react";

import styles from "./ProductDescription.module.scss";
import { Link } from "react-router";
import { IProduct } from "../../../../models/IProduct";

interface ProductDescriptionProps {
  product: IProduct | null;
}

const ProductDescription: React.FC<ProductDescriptionProps> = ({ product }) => {
  const [isTabOpened, setIsTabOpened] = React.useState({
    description: true,
    delivery: false,
    reviews: false,
  });

  const [quantity, setQuantity] = React.useState(1);

  const handleQuantityChange = (amount: number) => {
    setQuantity((prev) => Math.max(1, prev + amount));
  };

  return (
    <div className={styles.body}>
      <div className={styles.left}>
        <div className={styles.tabs}>
          <div
            className={`${styles.tab} ${isTabOpened.description ? styles.active : ""}`}
            onClick={() => setIsTabOpened({ delivery: false, description: true, reviews: false })}
          >
            Описание
          </div>
          <div
            className={`${styles.tab} ${isTabOpened.delivery ? styles.active : ""}`}
            onClick={() => setIsTabOpened({ delivery: true, description: false, reviews: false })}
          >
            Доставка и оплата
          </div>
          <div
            className={`${styles.tab} ${isTabOpened.reviews ? styles.active : ""}`}
            onClick={() => setIsTabOpened({ delivery: false, description: false, reviews: true })}
          >
            Отзывы
          </div>
        </div>
        <div className={styles.output}>
          {isTabOpened.description && (
            <div className={styles.description}>
              <p>
                {product?.description || "Описание товара появится позже."}
              </p>
            </div>
          )}
          {isTabOpened.delivery && (
            <div className={styles.delivery}>
              <p>Отправляем заказы</p>
              <p>
                Почтой России, СДЭК, Сбер-Логистика, DHL, EMS, Деловые линии, ЦАП, ПЭК, Энергия, DPD, КИТ, Байкал Сервис или любой
                другой удобной вам транспортной компанией.
              </p>
              <p>
                Стоимость доставки рассчитывается индивидуально согласно тарифам выбранного вами вида отправления, а также
                габаритов, веса, удаленности населенного пункта.
              </p>
              <p>
                Подробнее с условиями можно ознакомиться на странице <Link to="/delivery-and-payment">Доставка и оплата</Link>
              </p>
            </div>
          )}
          {isTabOpened.reviews && (
            <div className={styles.reviews}>
              <p>Отзывов пока нет.</p>
            </div>
          )}
        </div>
      </div>
      <div className={styles.right}>
        <h4 className={styles.rightTitle}>Цена оптом</h4>
        <div className={styles.priceSection}>
          <span className={styles.currentPrice}>{product ? `$${product.price_per_meter.toFixed(2)}` : "-"}</span>
          <span className={styles.oldPrice}>7.83$</span>
        </div>
        <div className={styles.quantitySection}>
          <p className={styles.quantityLabel}>Количество товара:</p>
          <div className={styles.quantityControl}>
            <button onClick={() => handleQuantityChange(-1)} aria-label="Уменьшить количество">
              -
            </button>
            <input
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value, 10) || 1))}
              aria-label="Количество"
            />
            <button onClick={() => handleQuantityChange(1)} aria-label="Увеличить количество">
              +
            </button>
          </div>
        </div>
        <button className={styles.addToCartButton}>Добавить в корзину</button>
        <button className={styles.addToWishlistButton}>
          <svg width="31" height="28" viewBox="0 0 31 28" fill="none">
            <path
              d="M21.4941 1L21.9316 1.01074C26.4283 1.23922 30 4.96927 30 9.53711C30 14.5893 27.6532 18.5783 24.8516 21.4453C22.0621 24.2998 18.7611 26.1088 16.6602 26.8252L16.6592 26.8242C16.2918 26.9519 15.8718 27 15.5 27C15.1279 27 14.7074 26.9521 14.3398 26.8242V26.8252C12.2389 26.1088 8.93792 24.2998 6.14844 21.4453C3.34677 18.5783 1.00001 14.5893 1 9.53711C1 4.82208 4.80565 1.00008 9.50586 1C11.8518 1 13.9671 1.95685 15.499 3.49609C16.1374 2.85474 16.8745 2.31595 17.6875 1.90625C18.8677 1.31157 20.1714 1.00116 21.4932 1H21.4941Z"
              fill="black"
              stroke="#495057"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.337 25.8787C15.878 26.0404 15.122 26.0404 14.663 25.8787C10.748 24.5438 2 18.9753 2 9.53708C2 5.37079 5.3615 2 9.506 2C11.963 2 14.1365 3.18652 15.5 5.02023C16.1936 4.08433 17.097 3.32368 18.1379 2.7992C19.1788 2.27473 20.3282 2.00102 21.494 2C25.6385 2 29 5.37079 29 9.53708C29 18.9753 20.252 24.5438 16.337 25.8787Z"
              fill="white"
            />
          </svg>
          В избранное
        </button>
        <div className={styles.contactSection}>
          <p className={styles.contactQuestion}>Есть вопрос?</p>
          <p className={styles.contactManager}>Свяжитесь с менеджером!</p>
          <div className={styles.contactIcons}>
            <span aria-label="Telegram">
              <svg width="51" height="51" viewBox="0 0 51 51" fill="none">
                <path
                  d="M25.4994 4.66663C13.9994 4.66663 4.66602 14 4.66602 25.5C4.66602 37 13.9994 46.3333 25.4994 46.3333C36.9994 46.3333 46.3327 37 46.3327 25.5C46.3327 14 36.9994 4.66663 25.4994 4.66663ZM35.166 18.8333C34.8535 22.125 33.4994 30.125 32.8119 33.8125C32.5202 35.375 31.9369 35.8958 31.3952 35.9583C30.1869 36.0625 29.2702 35.1666 28.1035 34.3958C26.2702 33.1875 25.2285 32.4375 23.4577 31.2708C21.3952 29.9166 22.7285 29.1666 23.916 27.9583C24.2285 27.6458 29.5619 22.7916 29.666 22.3541C29.6805 22.2879 29.6786 22.2191 29.6604 22.1537C29.6423 22.0884 29.6085 22.0284 29.5619 21.9791C29.4369 21.875 29.2702 21.9166 29.1244 21.9375C28.9369 21.9791 26.0202 23.9166 20.3327 27.75C19.4994 28.3125 18.7494 28.6041 18.0827 28.5833C17.3327 28.5625 15.916 28.1666 14.8535 27.8125C13.541 27.3958 12.5202 27.1666 12.6035 26.4375C12.6452 26.0625 13.166 25.6875 14.1452 25.2916C20.2285 22.6458 24.2702 20.8958 26.291 20.0625C32.0827 17.6458 33.2702 17.2291 34.0619 17.2291C34.2285 17.2291 34.6244 17.2708 34.8744 17.4791C35.0827 17.6458 35.1452 17.875 35.166 18.0416C35.1452 18.1666 35.1869 18.5416 35.166 18.8333Z"
                  fill="#343A40"
                />
              </svg>
            </span>
            <span aria-label="WhatsApp">
              <svg width="51" height="51" viewBox="0 0 51 51" fill="none">
                <path
                  d="M4.67437 46.3333L7.49104 35.9833C5.63507 32.8017 4.65999 29.1833 4.66604 25.5C4.66604 13.9937 13.9932 4.66663 25.4994 4.66663C37.0057 4.66663 46.3327 13.9937 46.3327 25.5C46.3327 37.0062 37.0057 46.3333 25.4994 46.3333C21.8177 46.3392 18.2008 45.3649 15.0202 43.5104L4.67437 46.3333ZM17.9807 15.725C17.7116 15.7417 17.4487 15.8125 17.2077 15.9333C16.9817 16.0613 16.7754 16.2213 16.5952 16.4083C16.3452 16.6437 16.2036 16.8479 16.0515 17.0458C15.2815 18.0479 14.8673 19.2779 14.8744 20.5416C14.8786 21.5625 15.1452 22.5562 15.5619 23.4854C16.414 25.3645 17.8161 27.3541 19.6682 29.1979C20.114 29.6416 20.5494 30.0875 21.0182 30.502C23.3169 32.5259 26.0562 33.9855 29.0182 34.7645L30.2036 34.9458C30.589 34.9666 30.9744 34.9375 31.3619 34.9187C31.9687 34.8874 32.5611 34.7231 33.0973 34.4375C33.3701 34.2969 33.6364 34.144 33.8952 33.9791C33.8952 33.9791 33.9848 33.9208 34.1557 33.7916C34.4369 33.5833 34.6098 33.4354 34.8432 33.1916C35.0161 33.0125 35.1661 32.802 35.2807 32.5625C35.4432 32.2229 35.6057 31.575 35.6723 31.0354C35.7223 30.6229 35.7077 30.3979 35.7015 30.2583C35.6932 30.0354 35.5077 29.8041 35.3057 29.7062L34.0932 29.1625C34.0932 29.1625 32.2807 28.3729 31.1744 27.8687C31.0578 27.8179 30.9328 27.7889 30.8057 27.7833C30.6631 27.7687 30.5191 27.7847 30.3833 27.8303C30.2474 27.876 30.1229 27.9501 30.0182 28.0479V28.0437C30.0077 28.0437 29.8682 28.1625 28.3619 29.9875C28.2755 30.1036 28.1564 30.1914 28.0198 30.2397C27.8833 30.2879 27.7355 30.2944 27.5952 30.2583C27.4595 30.222 27.3265 30.176 27.1973 30.1208C26.939 30.0125 26.8494 29.9708 26.6723 29.8937L26.6619 29.8895C25.4701 29.3692 24.3665 28.6663 23.3911 27.8062C23.1286 27.577 22.8848 27.327 22.6348 27.0854C21.8152 26.3005 21.1009 25.4125 20.5098 24.4437L20.3869 24.2458C20.2986 24.1128 20.2272 23.9693 20.1744 23.8187C20.0952 23.5125 20.3015 23.2666 20.3015 23.2666C20.3015 23.2666 20.8077 22.7125 21.0432 22.4125C21.2392 22.1631 21.4221 21.9037 21.5911 21.6354C21.8369 21.2395 21.914 20.8333 21.7848 20.5187C21.2015 19.0937 20.5973 17.675 19.9765 16.2666C19.8536 15.9875 19.489 15.7875 19.1577 15.7479C19.0452 15.7354 18.9327 15.7229 18.8202 15.7145C18.5405 15.7006 18.2601 15.7034 17.9807 15.7229V15.725Z"
                  fill="#343A40"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDescription;
